import { LOCAL_FONT_PROTOCOL } from "../../common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const EmojiFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LOCAL_FONT_PROTOCOL,
  },
];
